import {ff, form, FormBody} from "@mc/mc-legacy";
import {Col} from "@mc/ui-v3";
import React from "react";
import {connect} from "react-redux";
import {Button} from "reactstrap";
import {reduxForm} from "redux-form";

const validate = (formData) => {
    return {};
};

class PozadavkyForm extends React.Component {
    static formName = "PozadavkyForm";

    constructor(props) {
        super(props);
    }

    render() {
        const {handleSubmit, submitting} = this.props;

        return (
            <div className="w-100 d-flex justify-content-center">
                <Col xs={5} className="d-flex mt-2">
                    <form>
                        <FormBody>
                            <ff.Checkbox
                                onChange={handleSubmit}
                                label={false}
                                checkboxLabel="Povolit nový vlastní požadavek pro podepisujícího"
                                name="ownSignsEnabled"
                                disabled={submitting}
                            />
                            <ff.Checkbox
                                onChange={handleSubmit}
                                label={false}
                                checkboxLabel="Povolit nový požadavek pro předkladatele"
                                name="requestsEnabled"
                                disabled={submitting}
                            />
                            <Button color="primary" className="mt-4" onClick={handleSubmit}>
                                Aktualizovat
                            </Button>
                        </FormBody>
                    </form>
                </Col>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {};
}

export default connect(mapStateToProps)(
    reduxForm({
        initialValues: {},
        form: PozadavkyForm.formName,
        validate: validate,
    })(PozadavkyForm)
);
